
    export const CheckIcon = {
        paddingTop: "50%"
    }
    
    export const ThankYou = {
        fontSize: "22px",
        fontWeight: "bold"
    }

    export const Sent = {
        paddingTop: "5px"
    }
    
    export const AssistSoon = {
        paddingTop: "20px",
        fontSize: "15px"
    }